import { PERMISSIONS } from "@/services/permission"

export default [
  {
    path: "/machine/list",
    name: "MachineOverview",
    component: () => import("@/views/machine/MachineOverview"),
    meta: {
      title: "nav.machine.overview",
      requiresAuth: true,
      // Either right opens the page: it lists the catalogue's records and its packets, and shows
      // whichever of the two the reader may read (`services/catalogPackets.js`).
      requiresPermissions: [PERMISSIONS.VIEW_MACHINE_GENERAL, PERMISSIONS.VIEW_PACKET_GENERAL],
    },
  },
  {
    path: "/machine/create",
    name: "MachineCreate",
    component: () => import("@/views/machine/MachineCreate"),
    meta: {
      title: "machine.create.title",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.EDIT_MACHINE_GENERAL],
    },
  },
  {
    path: "/machine/:machineId",
    name: "MachineDetail",
    props: true,
    component: () => import("@/views/machine/MachineDetail"),
    meta: {
      title: "nav.machine.overview",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_MACHINE_GENERAL],
    },
  },
]
